import { Box, Button, Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import {
	ApplicationWordArt,
	AuthenticationButton,
	AuthenticationContainer,
	StyledLoginFormContainer,
} from "../../components";

export interface LoginInterstitialTemplateProps {
	readonly onSsoClicked: () => void;
	readonly onPasswordClicked: () => void;
}

export const LoginInterstitialTemplate: React.FC<LoginInterstitialTemplateProps> = ({
	onSsoClicked,
	onPasswordClicked,
}) => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<Grid container direction="column" gap={6}>
					<Box sx={{ margin: "auto" }}>
						<ApplicationWordArt width={300} />
					</Box>

					<Grid container direction="column" gap={2} alignItems="center">
						<AuthenticationButton
							type="button"
							variant="contained"
							fullWidth
							onClick={onSsoClicked}
							size="large"
							data-testid="login-interstitial__button__sso"
						>
							<FormattedMessage id="login-interstitial.sso" defaultMessage="Single Sign-On" />
						</AuthenticationButton>

						<Typography color="white" fontWeight="bold" variant="body2">
							<FormattedMessage id="login-interstitial.or" defaultMessage="- OR -" />
						</Typography>

						<Button
							type="button"
							variant="text"
							fullWidth
							onClick={onPasswordClicked}
							size="large"
							sx={{ color: "white" }}
							data-testid="login-interstitial__button__password"
						>
							<FormattedMessage id="login-interstitial.password" defaultMessage="Continue with password" />
						</Button>
					</Grid>
				</Grid>
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
